import axios from 'axios';

const defaultConfig = {
    baseURL: '/api',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
    },
};

const API = axios.create(defaultConfig);

API.interceptors.request.use(config => {
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
    }

    return config;
}, error => Promise.reject(error));

// Instance used by CMS resource calls (projects, news, events, ...). Rich-text bodies
// are sent as Markdown (not HTML), so no special transport handling is needed — this
// behaves like `API`; it's kept as a separate instance only to group CMS traffic.
const cmsApi = axios.create(defaultConfig);

cmsApi.interceptors.request.use(config => {
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
    }

    return config;
}, error => Promise.reject(error));

// Shared response-error handling for both instances.
const handleResponseError = error => {
    if (!error.response) {
        console.error('Network Error:', error);
        return Promise.reject(new Error('Network Error - Please check your internet connection.'));
    }

    const { status, data } = error.response;
    let errorMessage = data?.message || 'An unexpected error occurred. Please try again later.';

    if (!data?.message) {
        switch (status) {
            case 400:
                errorMessage = 'Bad Request - Check your input.';
                break;
            case 401:
                // utils.logout();
                errorMessage = 'Unauthorized - Session expired. Please log in again.';
                break;
            case 403:
                errorMessage = 'Forbidden - You do not have permission to perform this action.';
                break;
            case 404:
                errorMessage = 'Not Found - The requested resource was not found.';
                break;
            case 500:
                errorMessage = 'Internal Server Error - Please try again later.';
                break;
            case 503:
                errorMessage = 'Service Unavailable - The server is temporarily unable to service your request.';
                break;
            default:
                console.error(`Unhandled status code: ${status}`, error);
                break;
        }
    }

    return Promise.reject(new Error(errorMessage));
};

API.interceptors.response.use(response => response, handleResponseError);
cmsApi.interceptors.response.use(response => response, handleResponseError);

export { API, cmsApi };